module.exports = __webpack_public_path__ + "static/media/Products (11).fbfd5b05.png";